import React from 'react'

import { UseFormReturn } from 'react-hook-form'

import { FormField } from '@/components/ui/form'

import i18n from '@/i18n'

import { PhoneInput } from '../ui-custom/PhoneInput'
import { FormFieldWrapper } from './FormFieldWrapper'

interface PhoneFieldProps {
  form: UseFormReturn<any>
  name: string
  label: string
  placeholder?: string
  tooltip?: string
  desc?: string
  disabled?: boolean
  required?: boolean
  locale?: string
  defaultCountry?: string
  preferredCountries?: string[]
  onlyCountries?: string[]
  className?: string
}

export function PhoneField({
  form,
  name,
  label,
  placeholder = 'Enter a phone number',
  tooltip,
  desc,
  disabled,
  required = false,
  locale = 'en',
  defaultCountry = 'kw',
  preferredCountries = ['kw'],
  onlyCountries = ['kw'],
  className,
}: PhoneFieldProps) {
  // Detect RTL based on locale or document direction
  const isRTL = i18n.dir() === 'rtl'

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormFieldWrapper label={label} tooltip={tooltip} desc={desc} required={required}>
          <PhoneInput
            {...field}
            value={field.value}
            onChange={({ fullNumber }) => {
              field.onChange(fullNumber)
            }}
            placeholder={placeholder}
            locale={locale}
            defaultCountry={defaultCountry}
            preferredCountries={preferredCountries}
            onlyCountries={onlyCountries}
            disabled={disabled}
            isRTL={isRTL}
            className={className}
          />
        </FormFieldWrapper>
      )}
    />
  )
}

export const MemoizedPhoneField = React.memo(PhoneField) as typeof PhoneField
